<body [ngClass]="{'waiting': loading_data} ">
  <cdk-virtual-scroll-viewport (scroll)="scrolled($event)" itemSize="16" class="example-viewport">
    <div [style.top]="inverseOfTranslation" class="sticky-header box">
      <div>
        <div class="header-first xxsmall">Box</div>
        <div class="header small">ECMS ID</div>
        <div class="header small">Job Id</div>
        <div class="header large">Name</div>
        <div class="header xlarge">Address</div>
        <div class="header medium">Phone</div>
        <div class="header medium">Status</div>
        <div class="header large">Completed On</div>
        <div class="header large">MPRN</div>
        <div class="header medium">Hub Serial</div>
        <div class="header small">Eircode</div>
        <div class="header large">Last Seen Online</div>
        <div class="header large">Date Sent</div>
        <div class="header small">Hub Batch</div>
        <div class="header small">EI Batch</div>
        <div class="header xlarge">Comment</div>
        <div class="header large">Company Name</div>
      </div>
      <div>
        <div class="search-first xxsmall">
          <div class="flex-item-4">
            <input matInput placeholder="Filter" class="input-style-1" [(ngModel)]="searchParams.ecms_id">
            <mat-checkbox [(ngModel)]="checkAll" (change)="masterBox()"></mat-checkbox>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.ecms_id">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('ecms_id')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.job_id">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('job_id')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.first_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('first_name')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.address_line_1">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('address_line_1')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.contact_mobile">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('contact_mobile')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.ecms_status_text">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('ecms_status_text')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.end_time">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('end_time')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.mprn">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('mprn')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search medium">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.serial_no">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('serial_no')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.post_code">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('post_code')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.last_seen">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('last_seen')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.date_sent">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('date_sent')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.hub_batch">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('hub_batch')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search small">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.ei_batch">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('ei_batch')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search xlarge">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [(ngModel)]="searchParams.comment">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('comment')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
        <div class="search large">
          <div class="flex-box">
            <div class="flex-item-1">
              <input matInput placeholder="Filter" class="input-style" [attr.disabled]="true"
                [(ngModel)]="searchParams.company_name">
            </div>
            <div class="flex-item-2">
              <button class="button1" mat-button matSuffix (click)="search()">
                <mat-icon>search</mat-icon>
              </button>
            </div>
            <div class="flex-item-3">
              <button class="button1" mat-button matSuffix (click)="cancel('company_name')">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row box" *cdkVirtualFor="let entry of ecmsList; let index = index"
      [style.background-color]="this.getColor(index, entry.end_time, entry.last_seen)">
      <div class="column-first xxsmall">
        <mat-checkbox [checked]="checkForVal(entry.mprn)" (change)="addId(entry.mprn)"></mat-checkbox>
      </div>
      <div class="column small">{{entry.ecms_id}}</div>
      <div class="column small">
        <input matInput class="small_input" id="next_job_id" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.job_id, $event.srcElement.id)" [value]="entry.job_id"
          [(ngModel)]="entry.job_id"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_name" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.first_name, $event.srcElement.id)" [value]="entry.first_name"
          [(ngModel)]="entry.first_name"></div>
      <div class="column xlarge">
        <input matInput class="xlarge_input" id="next_address" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.address_line_1, $event.srcElement.id)"
          [value]="entry.address_line_1" [(ngModel)]="entry.address_line_1">
      </div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_phone" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.contact_mobile, $event.srcElement.id)"
          [value]="entry.contact_mobile" [(ngModel)]="entry.contact_mobile"></div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_status" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.ecms_status_text, $event.srcElement.id)"
          [value]="entry.ecms_status_text" [(ngModel)]="entry.ecms_status_text"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_completed_on" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.end_time, $event.srcElement.id)" [value]="entry.end_time"
          [(ngModel)]="entry.end_time"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_mprn" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.mprn, $event.srcElement.id)" [value]="entry.mprn"
          [(ngModel)]="entry.mprn"></div>
      <div class="column medium">
        <input matInput class="medium_input" id="next_serial_no" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.serial_no, $event.srcElement.id)" [value]="entry.serial_no"
          [(ngModel)]="entry.serial_no"></div>
      <div class="column small">
        <input matInput class="small_input" id="next_eircode" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.post_code, $event.srcElement.id)" [value]="entry.post_code"
          [(ngModel)]="entry.post_code"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_last_seen" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.last_seen, $event.srcElement.id)" [value]="entry.last_seen"
          [(ngModel)]="entry.last_seen"></div>
      <div class="column large">
        <input matInput class="large_input" id="next_date_sent" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.date_sent, $event.srcElement.id)" [value]="entry.date_sent"
          [(ngModel)]="entry.date_sent"></div>
      <div class="column small">
        <input matInput class="small_input" id="next_hub_batch" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.hub_batch, $event.srcElement.id)" [value]="entry.hub_batch"
          [(ngModel)]="entry.hub_batch"></div>
      <div class="column small">
        <input matInput class="small_input" id="next_ei_batch" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.ei_batch, $event.srcElement.id)" [value]="entry.ei_batch"
          [(ngModel)]="entry.ei_batch"></div>
      <div class="column xlarge">
        <input matInput class="xlarge_input" id="next_comment" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.comment, $event.srcElement.id)" [value]="entry.comment"
          [(ngModel)]="entry.comment">
      </div>
      <div class="column large">
        <input matInput class="large_input" id="next_company_name" (keyup.enter)="keytab($event)"
          (change)="updateLeads(entry.ecms_id, entry.company_name, $event.srcElement.id)" [value]="entry.company_name"
          [(ngModel)]="entry.company_name">
      </div>
    </div>
  </cdk-virtual-scroll-viewport>
</body>
